import { useContextFallback } from '@prenuvo/halo-foundation';

import { StudyGuardContext } from './study-guard.context';

export const useStudyGuard = () => useContextFallback(StudyGuardContext);
